/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Startlunch1Inputs */

const en__field_startlunch1 = /** @type {(inputs: _Field_Startlunch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunchbreak start`)
};

const de__field_startlunch1 = /** @type {(inputs: _Field_Startlunch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagspause Start`)
};

/**
* | output |
* | --- |
* | "Lunchbreak start" |
*
* @param {_Field_Startlunch1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_startlunch1 = /** @type {((inputs?: _Field_Startlunch1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Startlunch1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_startlunch1(inputs)
	return de__field_startlunch1(inputs)
});
export { _field_startlunch1 as "_field_startLunch" }